import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import Timeline from "../components/timeline"
import Topics from "../components/topics"
import Tools from "../components/tools"

const HomePage = () => {
  return (
    <div className="body">
      <Layout>
        <SEO title="Home" />
        <div className="grid-child intro">
          <div className="text-wrapper">
            <h1>ELLIOT YOUNG&#x27;S INTERNSHIP BLOG.</h1>
            <p className="page-paragraph">These are my reflections on interning remotely for <a href="https://www.wunderite.com/" className="link">Wunderite</a>, an insurance-tech startup based in Boston, MA during COVID-19. I started my internship in Woodlawn, Chicago on January 21st and have continued it quarantined in Markham, Ontario.</p>
            <p className="page-paragraph">The format of this blog is intentionally subversive and there is no correct order to browsing it. Readers are encouraged to follow linked ideas and read in the pattern that is most exciting to them. </p>
          </div>
        </div>
        <Timeline />
        <Topics />
        <Tools />
      </Layout>
    </div>
  )
}
export default HomePage